exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.el-select-dropdown__item.selected {\n  color: #0095f1;\n}\n.el-checkbox__input.is-checked + .el-checkbox__label {\n  color: #0095f1;\n}\n.el-checkbox__input.is-checked .el-checkbox__inner {\n  background-color: #0095f1;\n  border-color: #0095f1;\n}\n.el-checkbox__input.is-focus .el-checkbox__inner,\n.el-checkbox__inner:hover {\n  border-color: #0095f1;\n}\n.el-input-group__prepend .el-select {\n  width: 75px;\n}\n", ""]);

// exports
